import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { Accordion, AccordionDetails, AccordionSummary, Checkbox, FormControlLabel, TextField } from '@mui/material'
import _ from 'lodash'
import React, { useEffect, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import styles from './ProductFilterPriceRange.module.scss'
import { _at } from '../../../utils/translations'
import { FILTER_RANGE } from '../../OldProductFilter/productFilterConstants'
import ProductFilterActiveCount from '../ProductFilterActiveCount/ProductFilterActiveCount'

interface Props {
  min: string | null
  max: string | null
  saleItems: boolean
  onChange: (attributeId: string, minValue: string | null, maxValue: string | null, extra?: object) => void
}

const ProductFilterPriceRange: React.FC<Props> = (props: Props) => {
  const [min, setMin] = useState<string | null>(props.min)
  const [max, setMax] = useState<string | null>(props.max)
  const [isOnSale, setIsOnSale] = useState<boolean>(props.saleItems)

  useEffect(() => {
    setMin(props.min)
    setMax(props.max)
    setIsOnSale(props.saleItems)
  }, [props.min, props.max, props.saleItems])

  const handleMinChange = (event: React.SyntheticEvent<any, Event>) => setMin(event.currentTarget.value || null)
  const handleMaxChange = (event: React.SyntheticEvent<any, Event>) => setMax(event.currentTarget.value || null)
  const applyRangeChange = () => {
    props.onChange(FILTER_RANGE.PRICE, min, max, { ...(isOnSale ? { saleItems: '1' } : {}) })
  }
  const handleOnSaleChange = (event: React.ChangeEvent<any>, checked: boolean) => {
    setIsOnSale(checked)
    props.onChange(FILTER_RANGE.PRICE, min, max, { ...(checked ? { saleItems: '1' } : {}) })
  }

  const activeFilterCount = (min !== null ? 1 : 0) + (max !== null ? 1 : 0) + (isOnSale ? 1 : 0)

  return (
    <Accordion elevation={0} classes={{ root: styles['product-filter-price-range__accordion'] }}>
      <AccordionSummary
        classes={{
          root: styles['accordion_summary__root'],
          content: styles['accordion_summary__content'],
          expanded: styles['accordion_summary__content--expanded'],
        }}
        expandIcon={<ExpandMoreIcon />}
      >
        <FormattedMessage id="ProductFilter.Price" defaultMessage="Price" />
        {activeFilterCount ? <ProductFilterActiveCount count={activeFilterCount} /> : null}
      </AccordionSummary>
      <AccordionDetails>
        <div className={styles['content__range']}>
          <TextField
            label={<FormattedMessage id="ProductFilter.Price.From" defaultMessage="From" />}
            value={min || ''}
            type="number"
            onChange={handleMinChange}
            onBlur={applyRangeChange}
            className={styles['content__range__field']}
            InputLabelProps={{
              shrink: true,
            }}
            margin="normal"
          />
          <TextField
            label={<FormattedMessage id="ProductFilter.Price.To" defaultMessage="To" />}
            value={max || ''}
            onChange={handleMaxChange}
            onBlur={applyRangeChange}
            className={styles['content__range__field']}
            InputLabelProps={{
              shrink: true,
            }}
            margin="normal"
          />
        </div>
        <FormControlLabel
          label={<FormattedMessage id="ProductFilter.Price.SalePrice" defaultMessage="On Sale" />}
          control={<Checkbox color="primary" checked={isOnSale} onChange={handleOnSaleChange} />}
        />
      </AccordionDetails>
    </Accordion>
  )
}

export default ProductFilterPriceRange
